/***
 *
 *   BRAND RAMP PREVIEW
 *   The ten derived stops as swatches. "Aa" sits on 600 in the computed
 *   foreground (the public-page button) and in white on 800-900 (the sign-in
 *   panel).
 *
 *   Stop 600 is the hex they typed (View tickets / Submit). 800-900 may still
 *   darken so the sign-in panel's white heading stays readable. Showing the
 *   ramp here means they see both while choosing.
 *
 *   PROPS
 *   color: the hex being previewed
 *   label: heading above the swatches
 *
 **********/

import { deriveBrandRamp } from 'utilities/brand';
import Style from './brandRampPreview.tailwind.js';

const STOPS = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

const BRAND_STOP = 600;
// White heading on the project-auth gradient. 600 uses the computed
// foreground instead, because a light brand is no longer forced dark.
const WHITE_TEXT_STOPS = [800, 900];

export function BrandRampPreview(props) {
    const ramp = deriveBrandRamp(props.color);

    if (!ramp) return null;

    return (
        <div className={Style.wrapper}>
            {props.label && <p className={Style.label}>{props.label}</p>}

            <div className={Style.ramp}>
                {STOPS.map((stop) => (
                    <div
                        key={stop}
                        className={Style.swatch}
                        // Inline because the value is computed per keystroke —
                        // there is no class for an arbitrary tenant hex.
                        style={{ backgroundColor: `hsl(${ramp[stop]})` }}
                        title={`${stop} — hsl(${ramp[stop]})`}>
                        {(stop === BRAND_STOP || WHITE_TEXT_STOPS.includes(stop)) && (
                            <span
                                className={Style.sample}
                                style={
                                    stop === BRAND_STOP
                                        ? { color: `hsl(${ramp.foreground})` }
                                        : undefined
                                }>
                                Aa
                            </span>
                        )}
                    </div>
                ))}
            </div>

            <div className={Style.scale} aria-hidden>
                {STOPS.map((stop) => (
                    <span key={stop} className={Style.step}>
                        {stop}
                    </span>
                ))}
            </div>
        </div>
    );
}
